import { Breadcrumbs as WarpBreadcrumbs } from '@warp-ds/react/components/breadcrumbs';
import { useConfig } from 'shared/config/ConfigContext';
import type { Filters, PaleVertical } from '@/interfaces';
import { addResultPageFiltersToUrl } from '@/lib/utils/queryParamFilterConversions';

interface Props {
    vertical: PaleVertical;
    hotelName?: string;
    filters?: Filters;
}

export const Breadcrumbs = ({ vertical, hotelName, filters }: Props) => {
    const { contextPathPP } = useConfig();
    const resultPathPP = `${contextPathPP}/resultat`;

    return (
        <WarpBreadcrumbs>
            <a href="/reise/">Reise</a>
            {vertical === 'lms' ? <a href="/reise/restplasser/">Restplasser</a> : <a href="/reise/pakkereiser/">Pakkereiser</a>}
            {hotelName ? (
                [
                    <a href={filters ? addResultPageFiltersToUrl(resultPathPP, filters) : resultPathPP} key="breadcrumbResults">
                        Resultat
                    </a>,
                    <span className="truncate" aria-current="page" key="breadcrumbHotel">
                        {hotelName}
                    </span>,
                ]
            ) : (
                <span aria-current="page">Resultat</span>
            )}
        </WarpBreadcrumbs>
    );
};
